import type { PropsWithChildren } from 'react'
import Loading from '@c/loading/loading'
import { Suspense } from 'react'

const SuspenseWrapper = (props: PropsWithChildren) => (
  <Suspense fallback={<Loading className="h-500px" />}>{props.children}</Suspense>
)

export default SuspenseWrapper
